import React from 'react';
import Div from '../Div';
import './logolist.scss';

const technologies = [
  { name: 'ReactJS', icon: 'react', version: 'original' },
  { name: 'Next.js', icon: 'nextjs', version: 'original' },
  { name: 'TypeScript', icon: 'typescript', version: 'original' },
  { name: 'Tailwind CSS', icon: 'tailwindcss', version: 'plain' },
  { name: 'Vite JS', icon: 'vitejs', version: 'original' },
  { name: '.NET', icon: 'dotnetcore', version: 'original' },
  { name: 'C#', icon: 'csharp', version: 'original' },
  { name: 'Node.js', icon: 'nodejs', version: 'original' },
  { name: 'Java', icon: 'java', version: 'original' },
  { name: 'Spring Boot', icon: 'spring', version: 'original' },
  { name: 'Kotlin', icon: 'kotlin', version: 'original' },
  { name: 'Swift', icon: 'swift', version: 'original' },
  { name: 'Docker', icon: 'docker', version: 'original' },
  { name: 'Kubernetes', icon: 'kubernetes', version: 'plain' },
  { name: 'PostgreSQL', icon: 'postgresql', version: 'original' },
  { name: 'MySQL', icon: 'mysql', version: 'original' },
  { name: 'MongoDB', icon: 'mongodb', version: 'original' },
  { name: 'Redis', icon: 'redis', version: 'original' },
  { name: 'Flutter', icon: 'flutter', version: 'original' },
  { name: 'Git', icon: 'git', version: 'original' },
];

const duplicated = [...technologies, ...technologies];

export default function LogoList() {
  return (
    <Div className="cs-tech_logo_wrap">
      <Div className="cs-tech_logo_track">
        {duplicated.map((tech, index) => (
          <div className="cs-tech_logo_item" key={index} title={tech.name}>
            <img
              src={`https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/${tech.icon}/${tech.icon}-${tech.version}.svg`}
              alt={tech.name}
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </div>
        ))}
      </Div>
    </Div>
  );
}
